// extracted by mini-css-extract-plugin
module.exports = {"root":"_3w3FI"};